import { apiClient } from './apiClient';

export interface WFirmaVatCode {
  id: string;
  companyId: string;
  wfirmaId: number;
  code?: string;
  name?: string;
  rate: number;
  isEu: boolean;
  createdAt: string;
  updatedAt: string;
}

export const wfirmaVatCodeService = {
  // Получить список VAT кодов для компании
  getVatCodes: async (companyId: string): Promise<WFirmaVatCode[]> => {
    const response = await apiClient.get(`/companies/${companyId}/wfirma/vat-codes`);
    return response.data;
  },

  // Обновить список VAT кодов из wFirma
  refreshVatCodes: async (companyId: string): Promise<{ status: string; message: string }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/vat-codes/refresh`);
    return response.data;
  }
};
